import { render, staticRenderFns } from "./SeabornTapwaves.vue?vue&type=template&id=5a397155&scoped=true&"
import script from "./SeabornTapwaves.vue?vue&type=script&lang=js&"
export * from "./SeabornTapwaves.vue?vue&type=script&lang=js&"
import style0 from "./SeabornTapwaves.vue?vue&type=style&index=0&id=5a397155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a397155",
  null
  
)

export default component.exports